import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { Typography } from '@eventbrite/marmalade';

import React from 'react';
import { useEnvContext } from '../../context';
import styles from './NoFilterResults.module.scss';

import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import { DateOption, DATE_OPTIONS } from '../DateFilterDropdown';
import EmptyStateSvg from './__fixtures__/emptyState';

export interface NoFilterResultsProps {
    locationData: {
        latitude: number;
        longitude: number;
        isOnline?: boolean;
    };
    pageType: 'POI' | 'TTD' | '';
    handleToggle: (idx: number) => void;
    changeDateSelection: React.Dispatch<React.SetStateAction<DateOption>>;
}

export const NoFilterResults: React.FC<NoFilterResultsProps> = (props) => {
    const { env } = useEnvContext();

    const { handleToggle, changeDateSelection } = props;

    const handleClick = () => {
        if (HAS_WINDOW) {
            handleToggle(0);
            changeDateSelection(DATE_OPTIONS[0]);
        }
    };

    return (
        <div className={styles.root} data-testid="no-results-state">
            <EmptyStateSvg data-testid="no-results-svg" />
            <div className={styles.resultText}>
                <Typography
                    align="match-parent"
                    as="h2"
                    color="neutral-800"
                    variant={env?.isMobile ? 'heading-sm' : 'heading-md'}
                >
                    {gettext("We couldn't find anything with those filters")}
                </Typography>
                <Typography
                    align="match-parent"
                    color="neutral-800"
                    variant="body-lg"
                >
                    {gettext('Adjust or reset your filters to try again.')}
                </Typography>
            </div>
            <div className={styles.resetButton}>
                <Button
                    aria-label={'reset-all-filters'}
                    onClick={() => {
                        handleClick();
                    }}
                    variant="secondary"
                    size="responsive"
                >
                    {gettext('Reset all filters')}
                </Button>
            </div>
        </div>
    );
};
